export const irelandUniversities = {
  "trinity-college-dublin": {
    slug: "trinity-college-dublin", country: "ireland",
    name: "Trinity College Dublin", shortName: "TCD", flag: "🇮🇪",
    city: "Dublin", founded: 1592, qsRank: "#81 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1518005020951-eccb494ad742?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?q=80&w=900&auto=format&fit=crop",
    overview: "Ireland’s highest-ranked university, globally respected for computer science, business, medicine, and research.",
    tuition: { domestic: "€4,000–€9,000/yr", international: "€18,000–€32,000/yr" },
    living: "€1,100–€1,800/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "MSc Computer Science", duration: "1 year", language: "English" },
      { name: "MSc Data Science", duration: "1 year", language: "English" },
      { name: "MBA", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "95%", avgSalary: "€42,000–€75,000", topEmployers: ["Google", "Meta", "Accenture", "Deloitte"] },
    intakes: ["September", "January"], istpStudents: 22,
  },

  "university-college-dublin": {
    slug: "university-college-dublin", country: "ireland",
    name: "University College Dublin", shortName: "UCD", flag: "🇮🇪",
    city: "Dublin", founded: 1854, qsRank: "#171 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=900&auto=format&fit=crop",
    overview: "One of Europe’s largest modern campuses with strong business, engineering, and analytics programmes.",
    tuition: { domestic: "€4,000–€9,000/yr", international: "€17,000–€30,000/yr" },
    living: "€1,100–€1,750/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "MSc Business Analytics", duration: "1 year", language: "English" },
      { name: "MEng Mechanical Engineering", duration: "1 year", language: "English" },
      { name: "MBA", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "€40,000–€72,000", topEmployers: ["PwC", "KPMG", "Amazon", "EY"] },
    intakes: ["September", "January"], istpStudents: 20,
  },

  "university-college-cork": {
    slug: "university-college-cork", country: "ireland",
    name: "University College Cork", shortName: "UCC", flag: "🇮🇪",
    city: "Cork", founded: 1845, qsRank: "#273 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1509062522246-3755977927d7?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1496307653780-42ee777d4833?q=80&w=900&auto=format&fit=crop",
    overview: "Popular among international students for pharmaceuticals, food science, IT, and engineering.",
    tuition: { domestic: "€4,000–€8,000/yr", international: "€16,000–€28,000/yr" },
    living: "€900–€1,400/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "MSc Data Science & Analytics", duration: "1 year", language: "English" },
      { name: "MSc Food Science", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "€38,000–€65,000", topEmployers: ["Pfizer", "Apple", "Dell"] },
    intakes: ["September", "January"], istpStudents: 14,
  },

  "university-of-galway": {
    slug: "university-of-galway", country: "ireland",
    name: "University of Galway", shortName: "Galway", flag: "🇮🇪",
    city: "Galway", founded: 1845, qsRank: "#289 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",
    overview: "Known for med-tech, software engineering, biomedical science, and research.",
    tuition: { domestic: "€4,000–€8,000/yr", international: "€15,000–€26,000/yr" },
    living: "€850–€1,300/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "MSc Software Design", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "91%", avgSalary: "€37,000–€60,000", topEmployers: ["Medtronic", "Cisco"] },
    intakes: ["September"], istpStudents: 11,
  },

  "dublin-city-university": {
    slug: "dublin-city-university", country: "ireland",
    name: "Dublin City University", shortName: "DCU", flag: "🇮🇪",
    city: "Dublin", founded: 1975, qsRank: "#421 QS World 2025",
    // Dublin City University
    heroImg:
      "https://images.unsplash.com/photo-1498050108023-c5249f4df085?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1523240795612-9a054b0db644?q=80&w=900&auto=format&fit=crop",
    overview: "Industry-focused university known for computing, business, and communications.",
    tuition: { domestic: "€4,000–€8,000/yr", international: "€15,000–€24,000/yr" },
    living: "€1,100–€1,700/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "MSc Computing", duration: "1 year", language: "English" },
      { name: "MSc Finance", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "93%", avgSalary: "€39,000–€64,000", topEmployers: ["Google", "Bank of Ireland"] },
    intakes: ["September", "January"], istpStudents: 13,
  },

  "university-of-limerick": {
    slug: "university-of-limerick", country: "ireland",
    name: "University of Limerick", shortName: "UL", flag: "🇮🇪",
    city: "Limerick", founded: 1972, qsRank: "#426 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?q=80&w=900&auto=format&fit=crop",
    overview: "Excellent for engineering, robotics, supply chain, and cooperative education.",
    tuition: { domestic: "€4,000–€8,000/yr", international: "€14,000–€24,000/yr" },
    living: "€850–€1,250/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "MSc Artificial Intelligence", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "€38,000–€62,000", topEmployers: ["Dell", "Johnson & Johnson"] },
    intakes: ["September", "January"], istpStudents: 10,
  },

  "maynooth-university": {
    slug: "maynooth-university", country: "ireland",
    name: "Maynooth University", shortName: "MU", flag: "🇮🇪",
    city: "Maynooth", founded: 1997, qsRank: "#801+ QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?q=80&w=900&auto=format&fit=crop",
    overview: "Affordable and growing choice for data science, business, and humanities.",
    tuition: { domestic: "€4,000–€8,000/yr", international: "€14,000–€22,000/yr" },
    living: "€900–€1,300/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "MSc Data Analytics", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "89%", avgSalary: "€35,000–€56,000", topEmployers: ["Infosys", "Accenture"] },
    intakes: ["September", "January"], istpStudents: 9,
  },

  "technological-university-dublin": {
    slug: "technological-university-dublin", country: "ireland",
    name: "Technological University Dublin", shortName: "TU Dublin", flag: "🇮🇪",
    city: "Dublin", founded: 2019, qsRank: "#851+ QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1496307653780-42ee777d4833?q=80&w=900&auto=format&fit=crop",
    overview: "Career-driven university with strengths in IT, hospitality, engineering, and design.",
    tuition: { domestic: "€4,000–€8,000/yr", international: "€13,000–€21,000/yr" },
    living: "€1,000–€1,650/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [
      { name: "MSc Computing", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "88%", avgSalary: "€34,000–€54,000", topEmployers: ["SMEs", "Tech Firms"] },
    intakes: ["September", "January"], istpStudents: 8,
  },

  "south-east-technological-university": {
    slug: "south-east-technological-university", country: "ireland",
    name: "South East Technological University", shortName: "SETU", flag: "🇮🇪",
    city: "Waterford", founded: 2022, qsRank: "#Emerging",
    heroImg: "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?q=80&w=900&auto=format&fit=crop",
    overview: "Affordable option popular for computing, pharma, and engineering.",
    tuition: { domestic: "€4,000–€7,000/yr", international: "€12,000–€18,000/yr" },
    living: "€750–€1,100/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [
      { name: "MSc Computing", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "86%", avgSalary: "€32,000–€50,000", topEmployers: ["Regional Employers"] },
    intakes: ["September", "January"], istpStudents: 6,
  },

  "griffith-college-dublin": {
    slug: "griffith-college-dublin", country: "ireland",
    name: "Griffith College Dublin", shortName: "Griffith", flag: "🇮🇪",
    city: "Dublin", founded: 1974, qsRank: "#Private Institution",
    heroImg: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=900&auto=format&fit=crop",
    overview: "Well-known private college with strong business, law, and computing pathways.",
    tuition: { domestic: "€6,000–€10,000/yr", international: "€12,000–€18,000/yr" },
    living: "€1,000–€1,650/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [
      { name: "MBA", duration: "1 year", language: "English" },
      { name: "MSc Computing", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "85%", avgSalary: "€32,000–€48,000", topEmployers: ["SMEs", "Finance Firms"] },
    intakes: ["September", "January"], istpStudents: 7,
  },
};